import type { FaireProductEntity } from "../../entity_types/product";

export const p_ext9cfnlbs: FaireProductEntity = {
  token: "p_ext9cfnlbs",
  type: "product",
  name: "Black Ribbed Knotted Gown",
  brandToken: "b_3pci2bfmjr",
  brandName: "Three Little Tots",
  imageUrl:
    "https://cdn.faire.com/fastly/ce52f232fc0dbf03c17b4468ef9b41e7efdd6558d113d0ed334cfc21ddf34eaf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a561f76f4ae3c67e6a3a76cfd18194b0678ddef3fc18efa8f9cb820956a6f329.jpeg",
    "https://cdn.faire.com/fastly/11eed257d8a5ecc6dbe44ed91d0310fbfc811c026086b64a8916a5ab3969519f.jpeg",
    "https://cdn.faire.com/fastly/efcb2986e6e345fa5b4bf13c0dab49df3e457af4d6330db5f68991b8fa0efd40.jpeg",
    "https://cdn.faire.com/fastly/16e61c20a0f0ac43d1ec30c0c2f48fd103b5c532ad20c4e5dc1a6aa311d917fd.jpeg",
    "https://cdn.faire.com/fastly/37367df9d4a65e3d78dd09b25676af88c678e42dbfd5b983fbd9cd94d6807bff.jpeg",
    "https://cdn.faire.com/fastly/f940d7ac1014f8a68791dfa44873d8658580a8c5f87148132008c7a839116570.jpeg",
    "https://cdn.faire.com/fastly/d08ceb4193c8defbd02d96937fd091674162adca21cf8b043f114b6dd62652af.jpeg",
    "https://cdn.faire.com/fastly/c3e19857a4bfe46c7fc358dd2cb58e8c70f901352cc52bea223aced5647df52e.jpeg",
    "https://cdn.faire.com/fastly/e6e96b4dd7412774dbe08baae8b694a697cebea4abb7aa50df81f2f5b7e37c89.jpeg",
    "https://cdn.faire.com/fastly/8fcfc401d56a542cc9f43693f72fbf3f6e88016f290d8c470d76c22227fb3717.jpeg",
    "https://cdn.faire.com/fastly/7729dd00e4c467ecb84ba4df43bd9482a9ca3007cbd6cbe878777d407561506f.jpeg",
    "https://cdn.faire.com/fastly/4eebde389222332c7dc80267733eea4962c3eaca01c5c39f5c9848be97741bc3.jpeg",
    "https://cdn.faire.com/fastly/14134a8c361eca7b0b45e5f0a81e5dfa97e8fcc35a42363c7404c8f715d8033d.jpeg",
    "https://cdn.faire.com/fastly/574b22840cc1042b6d03bfd5c8d78fcd247de57d1320367e4c0142c12c696b5f.jpeg",
  ],
  priceDollars: 10.3,
  description:
    "These baby gowns are so soft you will never want your baby in anything else. Fabric is designed to be soft, comfortable, and stretchy. The tie bottom allows for easy night-time diaper change. The pull-down tabs on the shoulder make it easy to dress and change. Newborn-3 month fits approx 5lbs-15lbs.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:21.906Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
